// removed by extract-text-webpack-plugin
module.exports = {"title":"BuyerAssuranceBox-style__title__b7319c65","link":"BuyerAssuranceBox-style__link__b7319c65","benefits":"BuyerAssuranceBox-style__benefits__b7319c65","benefit":"BuyerAssuranceBox-style__benefit__b7319c65","icon":"BuyerAssuranceBox-style__icon__b7319c65","iconTrade":"BuyerAssuranceBox-style__iconTrade__b7319c65","copy":"BuyerAssuranceBox-style__copy__b7319c65"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/BuyerAssurance/BuyerAssuranceBox-style.scss
// module id = 3485
// module chunks = 7